import React, { useState } from 'react';
import { useField } from 'formik';
import bem from 'utils/bem';
import FormError from 'forms/fields/FormError';
import Icon from 'components/Icon';

import './index.sass'

const { cnBlock, el } = bem('form-field', 'form-password');

export default ({ className, name, ...props }) => {

    const [ type, setType ] = useState('password');

    const [field, meta] = useField({ name, type: 'password' });

    const togglePassword = () => setType((oldType) => oldType === 'password' ? 'text' : 'password' );

    return <div className={cnBlock(className, { 'invalid': meta.error && meta.touched})}>
        <div className={el('input')}>
            <input
                {...field}
                {...props}
                type={type}
            />
            <Icon name={'eye'} onClick={togglePassword}/>
        </div>
        {meta.error && meta.touched && <FormError>{meta.error}</FormError>}
    </div>
}
